import { Building2, Home } from "lucide-react"
import { cn } from "@/lib/utils/helpers"
import { SearchableSelect } from "@/components/ui/SearchableSelect"
import { SectionCard } from "@/components/ui/SectionCard"
import companyFormStyles from "@/features/company/styles/companyAdd.module.css"
import { transferSearchableTriggerClass } from "../../../constants/transferProcessStyles"
import type { TransferPropertyInfoSectionProps } from "./propertyInfoSectionTypes"

export function TransferPropertyCompanyTransferRow({ ctx }: TransferPropertyInfoSectionProps) {
  const {
    fragment,
    companyList,
    fkCompanyId,
    readOnlyControl,
    register,
    setValueValidated,
    loadCompany,
    debouncedLoadCompanySearch,
    companyOptionsLoading,
    handleCompanySelected,
  } = ctx
  const isTransferCompany = fragment === "transfer_company"
  const transferCompanyFieldGridClass = "grid grid-cols-1 gap-6 md:grid-cols-3"
  const showCompanyRequired = !String(fkCompanyId ?? "").trim()

  return (
    <SectionCard
      icon={isTransferCompany ? Building2 : Home}
      title={isTransferCompany ? "Company Information" : "Property Information"}
      testId="transfer-process-property-info-section"
      titleTestId="transfer-process-property-info-section-title"
    >
      <div
        data-testid="transfer-process-property-form-company-transfer-row"
        className={transferCompanyFieldGridClass}
      >
        <div className={companyFormStyles.formGroup}>
          <label
            data-testid="transfer-process-property-form-transfer-from-label"
            className={companyFormStyles.formLabel}
          >
            Transfer From
          </label>
          <input
            type="text"
            readOnly
            data-testid="transfer-process-property-form-transfer-from-input"
            className={cn(companyFormStyles.customFormControl, "bg-[#f8fafc]")}
            {...register("company_name")}
          />
        </div>
        <div className={companyFormStyles.formGroup}>
          <label
            data-testid="transfer-process-property-form-transfer-to-label"
            className={companyFormStyles.formLabel}
          >
            Transfer To<span className={companyFormStyles.requiredStar}>*</span>
          </label>
          <SearchableSelect
            className={transferSearchableTriggerClass}
            placeholder="Select Company"
            options={companyList}
            value={fkCompanyId}
            triggerDataTestId="transfer-process-property-form-transfer-to-company-select"
            onChange={(v) => {
              const id = Array.isArray(v) ? v[0] : v
              setValueValidated("fk_company_id", id)
              void handleCompanySelected(id)
            }}
            onOpen={() => void loadCompany(undefined, { silent: true })}
            onSearch={(s) => debouncedLoadCompanySearch(s)}
            invokeSearchOnClose={false}
            loading={companyOptionsLoading}
            disabled={readOnlyControl.includes("company")}
          />
          {(showCompanyRequired) && (
            <p
              data-testid="transfer-process-property-form-transfer-to-error"
              className="mt-1.5 text-xs text-rose-600"
            >
              Company Selection is required.
            </p>
          )}
        </div>
        <div className={companyFormStyles.formGroup}>
          <label
            data-testid="transfer-process-property-form-listed-label"
            className={companyFormStyles.formLabel}
          >
            Active?
          </label>
          <select
            data-testid="transfer-process-property-form-listed-select"
            className={companyFormStyles.customFormControl}
            {...register("listed")}
          >
            <option value="">Select Reference</option>
            <option value="1">Active</option>
            <option value="0">Not Active</option>
          </select>
        </div>
      </div>
    </SectionCard>
  )
}
